import { memo } from 'react';

import { twMerge } from 'tailwind-merge';

import Copy from '../Copy';

export type BadgeProps = {
  theme?: 'purple';
  text: string;
};

const Badge = ({ theme = 'purple', text }: BadgeProps) => {
  return (
    <div
      className={twMerge(
        'rounded-[12px] px-2 text-center',
        theme === 'purple' && 'bg-v2violet drop-shadow-[0_2px_4px_rgba(110,80,255,0.2)]',
      )}
    >
      <Copy
        className={twMerge('leading-[20px]', theme === 'purple' && 'text-white')}
        type="copy2"
        weight="medium"
      >
        {text}
      </Copy>
    </div>
  );
};

export default memo<BadgeProps>(Badge);
